import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ShareBarLikeDrawerPersonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  cursor: pointer;
`;

export const ShareBarLikeDrawerPersonInformationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & > :not(:last-child) {
    margin-right: 4px;
  }

  & > svg {
    min-width: 16px;
    min-height: 16px;
  }
`;

export const ShareBarLikeDrawerPersonNameContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 4px;
`;

export const ShareBarLikeDrawerPersonName = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;

  color: var(--color-text);
`;

export const ShareBarLikeDrawerPersonDate = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;

  color: rgba(23, 28, 51, 0.5);
`;

export const ShareBarLikeDrawerPersonCompanyContainer = styled.div`
  max-width: 50%;
  display: flex;
  flex-direction: row;
  align-items: center;

  & > :not(:last-child) {
    margin-right: 4px;
  }
`;

export const ShareBarLikeDrawerPersonCompany = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  text-align: end;

  color: rgba(23, 28, 51, 0.5);
`;
